module.exports = __webpack_public_path__ + "static/media/desktopScreenshot01.4a890938.jpg";